import { Col, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { CustomButton } from "ui";
import { CommonTable } from "components";
import { useStores } from "stores";
import { routes } from "constants/routes";
import { getCompaniesColumns } from "widgets";

export const CompaniesPage = observer(() => {
  const { companies, user } = useStores();
  const navigate = useNavigate();

  const { isUserAdmin } = user.roles;

  return (
    <Flex vertical gap="large">
      <Flex justify="space-between" align="center">
        <Typography.Title className="margin-none">Компании</Typography.Title>
        {isUserAdmin && (
          <CustomButton
            onClick={() => {
              navigate(`/${routes.companies}/create`);
            }}
          >
            Добавить компанию
          </CustomButton>
        )}
      </Flex>
      <CommonTable
        store={companies}
        columns={getCompaniesColumns({ companies })}
        onRow={(record) => ({
          onClick: () => {
            navigate(record.id);
          },
          className: "cursor-pointer",
        })}
        widgets={{
          search: true,
          date: true,
        }}
        whiteBox
      />
    </Flex>
  );
});
